import { performRequestSecond, performRequestThird, performRequestFourth } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getApiIdFromAppUrl, getTenantDetails } from 'utils/utils';
import { AppConfig } from 'config/api_config';

export const listExpenses = (filters, pageLimit = 10, pagination_token = '', pagination_direction = 'forward', next = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listExpenses}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&next=${next}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, filters);
};

export const listExpensesV2 = ({
  limit = 10,
  page = 1,
  expense_status = '',
  practice_area_list = [],
  case_id = '',
  expense_date_lower = '',
  expense_date_upper = '',
  sort_by,
  sort_order,
  search_key = '',
  full_list = false,
} = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listExpensesV2}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;

  const requestBody = {
    limit,
    page,
    expense_status,
    practice_area_list,
    case_id,
    expense_date_lower,
    expense_date_upper,
    sort_by,
    sort_order,
    search_key,
    full_list: full_list || false,
  };

  return performRequestSecond(apiEndPoints.methodType.POST, url, requestBody);
};

export const createExpense = (data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createExpense}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const getExpenseDetails = (expense_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getExpense}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&expense_sk=${expense_sk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const updateExpense = (data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateExpense}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const deleteExpense = (expense_sk, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.deleteExpense}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&expense_sk=${expense_sk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }`;
  return performRequestSecond(apiEndPoints.methodType.DELETE, url);
};

export const createExpenseType = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createExpenseType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const getExpenseTypeDetails = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getExpenseType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&sk=${sk}&pk=${pk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const updateExpenseType = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateExpenseType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const listExpenseType = (filters, pageLimit, pagination_token, pagination_direction, next = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listExpenseType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&next=${next}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, filters);
};

export const deleteExpenseType = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.deleteExpenseType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}`;
  return performRequestSecond(apiEndPoints.methodType.DELETE, url);
};

export const listPaymentStructure = (filters, limit = 1000, next = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listPaymentStructure}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${limit}&next=${next}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, filters);
};

export const updatePaymentStructure = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updatePaymentStructure}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const createTax = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createTax}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const updateTax = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateTax}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const listTax = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listTax}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const createPaymentRequest = (data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createPaymentRequest}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const updatePaymentRequest = (data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updatePaymentRequest}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${is_lead ? `&is_lead=${is_lead}` : ''}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const getPaymentRequest = (payment_request_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getPaymentRequest}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_request_sk=${payment_request_sk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const deletePaymentRequest = (payment_request_sk, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.deletePaymentRequest}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_request_sk=${payment_request_sk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }`;
  return performRequestSecond(apiEndPoints.methodType.DELETE, url);
};

export const listPaymentRequest = (data, pageLimit, pagination_token, pagination_direction) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listPaymentRequest}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}
  `;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const listPaymentRequestV2 = ({
  payment_request_status = '',
  case_id = '',
  search_key = '',
  payment_date_lower = '',
  payment_date_upper = '',
  practice_area_list = [],
  sort_by = '',
  sort_order = '',
  limit = 10,
  page = 1,
}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const endpoint = apiEndPoints.listPaymentRequestV2;
  let url = `${endpoint}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  const requestData = {
    payment_request_status: payment_request_status || '',
    case_id: case_id || null,
    search_key: search_key || null,
    payment_date_lower: payment_date_lower || null,
    payment_date_upper: payment_date_upper || null,
    practice_area_list: practice_area_list && practice_area_list.length > 0 ? practice_area_list : null,
    sort_by,
    sort_order,
    limit,
    page,
  };
  return performRequestSecond(apiEndPoints.methodType.POST, url, requestData);
};

export const createPaymentRecord = (data, payment_request_sk, isLead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createPaymentRecord}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_sk=${payment_request_sk}&is_lead=${isLead}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const getPaymentRecord = (payment_record_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getPaymentRecord}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_record_sk=${payment_record_sk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const listPaymentRecord = (data, pageLimit = 10, pagination_token = '', pagination_direction = 'forward', next = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listPaymentRecord}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&next=${next}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}
  `;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const listPaymentRecordV2 = (data, pageLimit = 10, page = 1) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listPaymentRecordV2}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&page=${page}&limit=${pageLimit}`;
  const requestData = {
    ...data,
  };
  return performRequestSecond(apiEndPoints.methodType.POST, url, requestData);
};

export const listPaymentRecordV3 = ({
  case_id = '',
  search_key = '',
  payment_date_lower = '',
  payment_date_upper = '',
  practice_area = [],
  sort_by = 'created_at',
  sort_order = 'desc',
  limit = 10,
  page = 1,
}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  // Ensure we're using V3 endpoint
  const endpoint = apiEndPoints.listPaymentRecordV3;
  let url = `${endpoint}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  const requestData = {
    case_id: case_id || null,
    search_key: search_key || null,
    payment_date_lower: payment_date_lower || null,
    payment_date_upper: payment_date_upper || null,
    practice_area: practice_area && practice_area.length > 0 ? practice_area : null,
    sort_by,
    sort_order,
    limit,
    page,
  };
  return performRequestSecond(apiEndPoints.methodType.POST, url, requestData);
};

export const updatePaymentRecord = (data, isLead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updatePaymentRecord}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&is_lead=${isLead}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const deletePaymentRecord = (payment_record_sk, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.deletePaymentRecord}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_record_sk=${payment_record_sk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }`;
  return performRequestSecond(apiEndPoints.methodType.DELETE, url);
};

export const createPaymentRefund = (data, payment_record_sk, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.createPaymentRefund}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_record_sk=${payment_record_sk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const sendPaymentRequestMail = (payment_request_sk, data, invoiceView = false, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = '';
  if (invoiceView) {
    url = `${apiEndPoints.sendInvoiceEmail}?tenant_id=${tenantId}&tenant_sk=${tenantSk}"&invoice_sk=${payment_request_sk}${
      is_lead ? `&is_lead=${is_lead}` : ''
    }`;
  } else {
    url = `${apiEndPoints.sendRequestMail}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_request_sk=${payment_request_sk}${
      is_lead ? `&is_lead=${is_lead}` : ''
    }`;
  }
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const getTrustAccountBalance = (trust_account_id, case_id) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getTrustAccountBalance}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&trust_account_id=${
    trust_account_id ? trust_account_id : ''
  }${case_id ? `&case_id=${case_id}` : ''}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const getOperatingAccountBalance = (operating_account_id, case_id) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getTrustAccountBalance}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&operating_account_id=${
    operating_account_id ? operating_account_id : ''
  }${case_id ? `&case_id=${case_id}` : ''}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const createPaymentReminder = (payment_request_sk, data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const apiId = getApiIdFromAppUrl(AppConfig?.baseURL2);

  let url = `${apiEndPoints.createPaymentReminder}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_sk=${payment_request_sk}&is_lead=${is_lead}&apiId=${apiId}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const updatePaymentReminder = (data, payment_request_sk, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const apiId = getApiIdFromAppUrl(AppConfig?.baseURL2);
  let url = `${apiEndPoints.updatePaymentReminder}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&payment_sk=${payment_request_sk}&is_lead=${is_lead}&apiId=${apiId}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const createInvoice = (data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const apiId = getApiIdFromAppUrl(AppConfig?.baseURL2);
  let url = `${apiEndPoints.createInvoice}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }&apiId=${apiId}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const listInvoice = (filter, pageLimit = 10, pagination_token = '', pagination_direction = 'forward', next = '') => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listInvoice}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${pageLimit}&next=${next}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, filter);
};

export const listInvoiceV2 = ({
  limit = 10,
  page = 1,
  invoice_status = '',
  practice_area_list = [],
  case_id = '',
  invoice_date_lower = '',
  invoice_date_upper = '',
  sort_by,
  sort_order,
  search_key = '',
  lead_attorney_list = [],
  lead_paralegal_list = [],
  batch_invoice = false,
  timezone_offset = '',
} = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listInvoiceV2}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;

  const requestBody = {
    limit,
    page,
    invoice_status,
    practice_area_list,
    case_id,
    invoice_date_lower,
    invoice_date_upper,
    sort_by,
    sort_order,
    search_key,
    lead_attorney_list,
    lead_paralegal_list,
    batch_invoice,
    timezone_offset,
  };

  return performRequestSecond(apiEndPoints.methodType.POST, url, requestBody);
};

export const getInvoiceNumber = () => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getInvoiceNumber}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const getClientPaymentDetails = (
  contact_id,
  data,
  pageLimit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  case_id = null
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getClientPaymentDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&contact_id=${contact_id}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  if (case_id) {
    url += `&case_id=${encodeURIComponent(case_id)}`;
  }
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const getInvoice = (invoice_sk, options = {}) => {
  const { getTrustBalance = false } = options;
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getInvoice}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&invoice_sk=${invoice_sk}`;
  if (getTrustBalance) {
    url += '&get_trust_balance=true';
  }
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const getClientInvoiceList = (
  contact_id,
  data,
  pageLimit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  case_id = null
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listClientInvoices}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&contact_id=${contact_id}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  if (case_id) {
    url += `&case_id=${encodeURIComponent(case_id)}`;
  }
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const getFlatFeeBillingDashboard = (tenant_id, tenant_sk, case_id, contact_id, ledger_page = 1, ledger_page_size = 10) => {
  let url = `${apiEndPoints.getFlatFeeBillingDashboard}?tenant_id=${tenant_id}&tenant_sk=${tenant_sk}&case_id=${case_id}&contact_id=${contact_id}&ledger_page=${ledger_page}&ledger_page_size=${ledger_page_size}`;
  return performRequestFourth(apiEndPoints.methodType.GET, url);
};

export const getClientPortalBillingDashboard = (tenant_id, tenant_sk, case_id, contact_id, payment_type = 'retainer') => {
  const url = `${apiEndPoints.getClientPortalBillingDashboard}?tenant_id=${tenant_id}&tenant_sk=${tenant_sk}&case_id=${case_id}&contact_id=${contact_id}&payment_type=${payment_type}`;
  return performRequestFourth(apiEndPoints.methodType.GET, url);
};

export const getClientFeeLedger = (tenant_id, tenant_sk, case_id, contact_id, page = 1, page_size = 10) => {
  let url = `${apiEndPoints.getClientFeeLedger}?tenant_id=${tenant_id}&tenant_sk=${tenant_sk}&case_id=${case_id}&contact_id=${contact_id}&page=${page}&page_size=${page_size}`;
  return performRequestFourth(apiEndPoints.methodType.GET, url);
};

export const getClientBillingSummary = (contact_id, excludeFromLoading = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.clientBillingSummary}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&contact_id=${contact_id}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url, null, '', true, excludeFromLoading);
};

export const getSubscriptionPlan = (case_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getSubscriptionPlan}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&case_sk=${case_sk}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const listBatchBilling = ({
  limit = 30,
  page = 1,
  lead_attorney_list = [],
  lead_paralegal_list = [],
  practice_area_list = [],
  search_keyword = '',
  uninvoiced_billable_time = true,
  uninvoiced_nonbillable_time = true,
  uninvoiced_expenses = true,
  unpaid_invoice_balance = true,
  case_list = [],
  start_date = null,
  end_date = null,
} = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.batchBillingList}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;

  const requestBody = {
    limit,
    page,
    lead_attorney_list,
    lead_paralegal_list,
    practice_area_list,
    search_keyword,
    uninvoiced_billable_time,
    uninvoiced_nonbillable_time,
    uninvoiced_expenses,
    unpaid_invoice_balance,
    ...(case_list && case_list.length > 0 && { case_list }),
    ...(start_date && { start_date }),
    ...(end_date && { end_date }),
  };

  return performRequestSecond(apiEndPoints.methodType.POST, url, requestBody);
};

const toList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  return String(value).split(',').filter(Boolean);
};

export const listBatchInvoices = ({
  limit = 10,
  page = 1,
  date_from = null,
  date_to = null,
  practice_area_list = [],
  lead_attorney_list = [],
  lead_paralegal_list = [],
  search_keyword = '',
} = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.batchInvoiceList}?tenant_id=${tenantId}&tenant_sk=${encodeURIComponent(tenantSk)}`;

  const requestBody = {
    limit: String(limit),
    page: String(page),
    date_from: date_from || '',
    date_to: date_to || '',
    practice_area_list: toList(practice_area_list),
    lead_attorney_list: toList(lead_attorney_list),
    lead_paralegal_list: toList(lead_paralegal_list),
    search_keyword: search_keyword || '',
  };

  return performRequestFourth(apiEndPoints.methodType.POST, url, requestBody);
};

export const deleteInvoice = (invoice_sk, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.deleteInvoice}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&invoice_sk=${invoice_sk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }`;
  return performRequestSecond(apiEndPoints.methodType.DELETE, url);
};

export const updateInvoice = (data, is_lead = false) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const apiId = getApiIdFromAppUrl(AppConfig?.baseURL2);
  let url = `${apiEndPoints.updateInvoice}?tenant_id=${tenantId}&tenant_sk=${tenantSk}${
    is_lead ? `&is_lead=${is_lead}` : ''
  }&apiId=${apiId}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};

export const listTrustAccount = ({ filter, limit = 100, pagination_direction = 'forward', pagination_token = '' }) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listTrustAccount}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&limit=${limit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, filter);
};

export const listTrustAccountV2 = ({
  case_id = null,
  contact_id = null,
  account_id = null,
  account_type = null,
  transaction_date_lower = null,
  transaction_date_upper = null,
  source_account_id = [],
  destination_account_id = [],
  sort_by = '',
  sort_order = '',
  limit = 10,
  page = 1,
}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const endpoint = apiEndPoints.listTrustAccountV2;
  let url = `${endpoint}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  const requestData = {
    case_id: case_id || null,
    contact_id: contact_id || null,
    account_id: account_id || null,
    account_type: account_type || null,
    transaction_date_lower: transaction_date_lower || null,
    transaction_date_upper: transaction_date_upper || null,
    source_account_id: source_account_id && source_account_id.length > 0 ? source_account_id : null,
    destination_account_id: destination_account_id && destination_account_id.length > 0 ? destination_account_id : null,
    sort_by,
    sort_order,
    limit,
    page,
  };
  return performRequestSecond(apiEndPoints.methodType.POST, url, requestData);
};

export const sendInvoiceReport = (params) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.sendInvoice}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${params}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, {});
};

export const getTrustBalanceInfo = (case_sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.getTrustBalanceInfo}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&case_sk=${case_sk}`;
  return performRequestThird(apiEndPoints.methodType.GET, url);
};

export const listModuleType = (
  next = '',
  limit = 10,
  pagination_token = '',
  pagination_direction = 'forward',
  excludeFromLoading = true
) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listModuleType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&next=${next}&limit=${limit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  return performRequestThird(apiEndPoints.methodType.GET, url, null, null, true, excludeFromLoading);
};

export const validateModuleMapping = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.validateModuleType}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const recordCaseExpensePayment = (data) => {
  const [tenantId] = getTenantDetails();
  let url = `${apiEndPoints.recordCaseExpensePayment}?tenant_id=${tenantId}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const disburseTrustFund = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.disburseTrustFund}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestSecond(apiEndPoints.methodType.POST, url, data);
};

export const transferTrustFund = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.transferTrustFund}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const invoiceTimeEntry = (invoiceId, data, case_id, case_name) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.invoiceTimeEntry}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&invoice_id=${invoiceId}&case_id=${case_id}&case_name=${case_name}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const invoiceExpenses = (invoiceId, data, case_id, case_name) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.invoiceExpenses}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&invoice_id=${invoiceId}&case_id=${case_id}&case_name=${case_name}`;
  return performRequestThird(apiEndPoints.methodType.POST, url, data);
};

export const invoiceQuickBooksUpdate = (pk, sk, case_id, is_trust_account, mode_of_operation) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.invoiceQuickBooksUpdate}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pk}&sk=${sk}&case_id=${case_id}&is_trust_account=${is_trust_account}&mode_of_operation=${mode_of_operation}`;
  return performRequestThird(apiEndPoints.methodType.GET, url, null, '', true, true);
};

export const getBatchBillingAggregate = ({
  case_list = [],
  start_date = null,
  end_date = null,
  uninvoiced_billable_time = true,
  uninvoiced_expenses = true,
  uninvoiced_nonbillable_time = true,
  unpaid_invoice_balance = true,
} = {}) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.batchBillingAggregate}?tenant_id=${tenantId}&tenant_sk=${tenantSk}`;
  const requestBody = {
    case_list,
    uninvoiced_billable_time,
    uninvoiced_expenses,
    uninvoiced_nonbillable_time,
    unpaid_invoice_balance,
    ...(start_date && { start_date }),
    ...(end_date && { end_date }),
  };
  return performRequestFourth(apiEndPoints.methodType.POST, url, requestBody);
};

export const createBatchInvoice = (data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.batchInvoiceCreation}?tenant_id=${tenantId}&tenant_sk=${encodeURIComponent(tenantSk)}`;
  return performRequestFourth(apiEndPoints.methodType.POST, url, data);
};
